









import { Component, Vue, Watch } from 'vue-property-decorator'
import BaseButton from '@/components/reusable-components/controls/BaseButton.vue'
import IconBurger from '@/components/icons/IconBurger.vue'
import HeaderMobileMenu from '@/components/layout/header/HeaderMobileMenu.vue'

@Component({
    components: { HeaderMobileMenu, IconBurger, BaseButton },
})
export default class HeaderMobileNavigation extends Vue {
    open = false

    @Watch('$route')
    onRouteChanged() {
        this.open = false
    }
}
